export default function isObservable(value) {
    return typeof value.subscribe === 'function';
}
//# sourceMappingURL=is-observable.js.map